import type { DetailedSummaryResponseProps } from '@pages/Invoicing/context/types'

export const setInitialValues = (data: DetailedSummaryResponseProps) => {
  return {
    minimumBilling: Number(data.minimumBilling).toFixed(2),
    provisions: Number(data.provisions).toFixed(2),
    reversals: Number(data.reversals).toFixed(2),
    adjustments: Number(data.adjustments).toFixed(2)
  }
}
